import React from 'react';
import BaseButton from 'components/atoms/baseButton';
import classNames from 'classnames';
import { ArrowUpLightIcon } from 'components/atoms/icons/arrowUpLight';

import s from './styles.module.scss';

import type { MouseEvent } from 'react';

interface IProps {
  expanded: boolean;
  dataCy?: string;
  className?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const ExpandButton: React.FC<IProps> = (props) => {
  const { expanded, onClick, className, dataCy = 'expand-button' } = props;

  const toggleIcon = (
    <i
      className={classNames(s.icon, {
        [s.opened]: expanded,
      })}
    >
      <ArrowUpLightIcon />
    </i>
  );

  return (
    <BaseButton
      className={className}
      type="secondary"
      onClick={onClick}
      icon={toggleIcon}
      dataCy={dataCy}
    />
  );
};

export default ExpandButton;
